import brands from "@/../../hypetrain/static/img/brands.svg";
import lightBrands from "@/../../hypetrain/static/img/light-brands.svg";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { Container } from "@/components/pieces/bootstrap";
import {
  DARK_PURPLE,
  MIDTEXT_COLOR,
  OPACITY_TRANSITION,
  PUBLIC_CONTENT_MAX_WIDTH,
} from "@/css/constants";

export default function Brands({
  opacity,
  backgroundColor = DARK_PURPLE,
  light = false,
}) {
  return (
    <Box css={{ backgroundColor }} py={40}>
      <Box css={{ opacity, transition: OPACITY_TRANSITION }}>
        <Flex justifyContent="center" pb={30}>
          <Box
            css={{
              color: light ? MIDTEXT_COLOR : "#FFF",
              fontSize: 24,
              textAlign: "center",
            }}
          >
            <b>Trusted by talent from top companies</b>
          </Box>
        </Flex>
        <Flex justifyContent="center">
          <BrandContainer>
            <Container>
              <Flex className="inner">
                <EmbedSvg
                  width={PUBLIC_CONTENT_MAX_WIDTH}
                  height="37"
                  src={light ? lightBrands : brands}
                />
              </Flex>
            </Container>
          </BrandContainer>
        </Flex>
      </Box>
    </Box>
  );
}

const floating = keyframes`
  0% { transform: translateX(0%); }
  50% { transform: translateX(-100%); }
  100% { transform: translateX(0%); }
`;

const BrandContainer = styled(Box)`
  position: relative;
  height: 40px;
  width: 100%;
  overflow-x: hidden;
  .inner {
    position: absolute;
    width: 100%;

    @media screen and (max-width: ${breakpoints.lg}px) {
      animation: ${floating} 45s linear infinite;
    }
  }
`;
